import { render, staticRenderFns } from "./CardCreatePopUp.vue?vue&type=template&id=345d21e9&scoped=true"
import script from "./CardCreatePopUp.vue?vue&type=script&lang=js"
export * from "./CardCreatePopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345d21e9",
  null
  
)

export default component.exports